import styled from 'styled-components';
import theme from '../../theme';

const StyledIndusindMinKyc = styled.div`
  .custom-info-icon{
    margin-left: 5px;
    height: 8px;
    width: 8px;
    color: ${theme.iconYellow};
  }
  .ant-input{
    &.custom-input{
      height: 35px;
      border-radius: 6px;
    }
  }
  .ant-select{
    &.custom-select{
      .ant-select-selection{
        height: 35px;
        border-radius: 6px;
      }
      .ant-select-selection__rendered{
        line-height: 35px;
      }
    }
  }
  .ant-calendar-picker{
    &.custom-datepicker {
      width: 100%;
      .ant-calendar-picker-input{
        height: 35px;
        border-radius: 6px;
      }
    }
  }
  .outline-gray{
    border: 1px dashed ${theme.borderGray};
    border-radius: 4px;
    padding-bottom: 10px;
    background-color: ${theme.touchFeatherGray};
    .close-icon{
      height: 20px;
    }
  }
  .line-ht-20{
    line-height: 20px;
  }
  .red-clr{
    color: ${theme.primaryColor};
  }
  .custom-ant-steps{
    &.ant-steps-label-vertical .ant-steps-item-tail{
      margin-left: 70px;
      padding: 3.5px 14px;
    }
    .ant-steps-item{
      &.ant-steps-item-active{
        .ant-steps-item-container{
          .ant-steps-item-content{
            .ant-steps-item-title{
              color: ${theme.primaryColor};
            }
          }
        }
      }
    }
    .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after{
      background-color:${theme.blackColor};
    }
    .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after{
      background-color:${theme.blackColor};
    }
    .ant-steps-item-wait .ant-steps-item-icon{
      border-color:${theme.primaryColor};
    }
    .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon{
      color:transparent ;
    }
    &.ant-steps .ant-steps-item-finish .ant-steps-item-icon{
      background: ${theme.whiteColor} !important;
      border-color: ${theme.btnGreen} !important;
    }
    &.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon{
      display: none;
    }
    &.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon{
      display: none;
    }
    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after{
      background-color: ${theme.btnGreen};
      height:3px;
    }
    .ant-steps-item-wait .ant-steps-item-icon,
    .ant-steps-item-process .ant-steps-item-icon,
    .ant-steps-item-finish .ant-steps-item-icon {
      border-color:${theme.primaryColor};
      background: ${theme.whiteColor};
      position:relative;
      border: 2px solid ${theme.primaryColor};
      width: 22px;
      height: 22px;
      top: -5px;
      margin-left: 60px;
      &:after{
        content:"";
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: ${theme.primaryColor};
        display: inline-block;
        margin-bottom: -4px;
      }
    }
    .ant-steps-item-wait .ant-steps-item-icon{
      border: 2px solid ${theme.grayColor};
      line-height: 10px;
      &:after{
        background-color: ${theme.grayColor};
      }
    }
    .ant-steps-item-finish .ant-steps-item-icon{
      line-height: 10px;
      &:after{
        background-color: ${theme.btnGreen} !important;
      }
    }
    .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon{
      display:none ;
      line-height: 8px;
    }
    .ant-steps-item-finish{
      .ant-steps-item-content{
        .ant-steps-item-title{
          color: ${theme.btnGreen} !important;
          line-height: 24px;
        }
      }
    }
    .ant-steps-icon-dot{
      left:auto !important;
      top:auto !important;
    }
    .ant-steps-item-content{
      margin-top: 0px;
      .ant-steps-item-title{
        font-size: 13px;
        line-height: 24px;
        font-weight: 600;
        color: ${theme.grayColor};
      }
    }
  }
`;


export {
  StyledIndusindMinKyc,
};



// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/StyledIndusIndMinkyc.js